import React from "react";
import { RadioButton } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { ALL_WEEKDAYS, } from "../../types/schedule";
export var WeekdaySingleEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement("div", null, ALL_WEEKDAYS.map(function (day) { return (React.createElement(RadioButton, { key: day, name: "weekday-single", label: formatMessage({
            id: "ui-br-legaldeposits.schedule.weekday.".concat(day),
        }), checked: value.weekday === day, onChange: function () { return onChange({ weekday: day }); }, disabled: disabled })); })));
};
